import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useIsLogged } from "../../../hooks/auth/use-is-logged/use-is-logged";
import { getUserSubscriptionAccount } from "./user-subscription.api";
import { userSubscriptionQueryKeys } from "./user-subscription.query-keys";
import type { UserSubscriptionAccount } from "./types/user-subscription-account.entity";

export interface IUseUserSubscriptionAccountQuery {
  account: UserSubscriptionAccount | undefined;
  isLoading: boolean;
  error: Error | undefined;
  revalidate: () => Promise<boolean>;
}

export function useUserSubscriptionAccountQuery(): IUseUserSubscriptionAccountQuery {
  const isLogged = useIsLogged();
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: userSubscriptionQueryKeys.account(),
    queryFn: getUserSubscriptionAccount,
    enabled: isLogged,
  });

  async function revalidate(): Promise<boolean> {
    await queryClient.invalidateQueries({
      queryKey: userSubscriptionQueryKeys.account(),
    });
    return true;
  }

  return {
    account: isLogged ? query.data : undefined,
    isLoading: query.isFetching,
    error: query.error as Error | undefined,
    revalidate,
  };
}
